<app-alert *ngIf="alertVisible && !hideModal" type="info" [btnPosition]="'space-between'">
  <ng-container alert-title>{{ 'currency-notifier.title' | customLocale }}</ng-container>
  <ng-container alert-body>
    {{ 'currency-notifier.question' | customLocale : { from: this.myCurrency, to: this.queryCurrency } }}
  </ng-container>
  <ng-container alert-buttons>
    <on-ui-button label="currency-notifier.btn-skip" class="primary outline" (onclick)="skip()"> </on-ui-button>
    <on-ui-button
      label="currency-notifier.btn-save"
      [state]="saveState"
      [disabled]="saveState !== 'default'"
      class="primary"
      (onclick)="changeCurrency()">
    </on-ui-button>
  </ng-container>
</app-alert>
